import { usePostSubmitActions } from "@circle-react/components/QuickPostV3/Composer/usePostSubmitActions";
import { QUICK_POST_V3_FORM_ID } from "@circle-react/components/QuickPostV3/constants";
import { useSubmitEligibility } from "@circle-react/components/QuickPostV3/hooks/useSubmitEligibility";
import { Button } from "@circleco/compass/components/Button";
import { SplitButton } from "@circleco/compass/components/SplitButton";
import { Tooltip } from "@circleco/compass/components/Tooltip";
import { useRef } from "react";

import { FooterSchedulePicker } from "@/react/components/PostsCompass/FooterSchedulePicker";

export const SubmitButton = () => {
  const containerRef = useRef<HTMLDivElement>(null);
  const { errorMessage, isDisabled } = useSubmitEligibility();
  const {
    disabledDays,
    getSubmitLabel,
    isEdit,
    isFooterSchedulePickerOpen,
    menuOptions,
    onScheduleDateSave,
    scheduledAt,
    selectedAction,
    setIsFooterSchedulePickerOpen,
    shouldRenderFooterSchedulePicker,
    shouldShowActionSelector,
  } = usePostSubmitActions();

  return (
    <div ref={containerRef}>
      {shouldRenderFooterSchedulePicker && (
        <FooterSchedulePicker
          anchor={containerRef}
          disabledDays={disabledDays}
          onOpenChange={setIsFooterSchedulePickerOpen}
          onSave={onScheduleDateSave}
          open={isFooterSchedulePickerOpen}
          value={scheduledAt}
        />
      )}
      <Tooltip content={errorMessage ?? ""} disabled={!errorMessage}>
        {shouldShowActionSelector ? (
          <SplitButton
            variant="primary"
            size="md"
            disabled={isDisabled}
            form={QUICK_POST_V3_FORM_ID}
            type="submit"
            align="end"
            side="top"
            menuOptions={menuOptions}
          >
            {selectedAction.label}
          </SplitButton>
        ) : (
          <Button
            variant="primary"
            size="md"
            disabled={isDisabled}
            form={QUICK_POST_V3_FORM_ID}
            type="submit"
          >
            {getSubmitLabel({ isEdit })}
          </Button>
        )}
      </Tooltip>
    </div>
  );
};
